module.exports = __webpack_public_path__ + "img/camp_shirt_other11.257bc400.svg";